import Vue from "vue";
import Vuex from "vuex";
import axios from "@/app/plugins/Axios";

Vue.use(Vuex);

import modules from "./modules";

export default new Vuex.Store({
  state: {
    titulo_tela: "Sistema Gerencial",
    loading: false,
    drawerRight: false,
    configuracoes: {},
    lista_configuracoes: [],
    drawer: true,
  },

  mutations: {
    setTitulo(state, titulo) {
      state.titulo_tela = titulo;
    },

    LOADING(state, loading) {
      state.loading = loading;
    },

    LOADING_ON(state) {
      state.loading = true;
    },

    LOADING_OFF(state) {
      state.loading = false;
    },

    TOGGLE_RIGHT_DRAWER(state) {
      state.drawerRight = !state.drawerRight;
    },

    SET_CONFIGURACOES(state, configuracoes) {
      state.configuracoes = configuracoes;
    },

    UPDATE_CONFIGURACAO(state, configuracao) {
      state.configuracoes[configuracao.config] = configuracao.valor;
    },

    SET_LISTA_CONFIGURACOES(state, configuracoes) {
      state.lista_configuracoes = configuracoes;
    },

    ADD_CONFIGURACOES(state, configuracoes) {
      state.configuracoes = { ...state.configuracoes, ...configuracoes };
    },

    SET_DRAWER(state, drawer) {
      state.drawer = drawer;
    },

  },

  actions: {
    carregarConfiguracoes({ commit }) {
      axios.get("configuracoes").then((response) => {
        commit("SET_CONFIGURACOES", response.data);
      });
    },

    carregarListaConfiguracoes({ commit }) {
      return axios.get("configuracoes/lista").then((response) => {
        commit("SET_LISTA_CONFIGURACOES", response.data);
      });
    },

    atualizar({ commit }, configuracao) {
      return axios.put("configuracoes", configuracao);
    },

    salvar({ commit }, configuracao) {
      return axios.post("configuracoes", configuracao);
    },
  },

  modules: modules,
});
